import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ConsultantsWithAccess from './ConsultantsWithAccess';
import ConsultantsWithAccessForm from './ConsultantsWithAccessForm';
import { handleError } from '../store/features/alertSlice';
import claimGroupRolesService from '../services/claim_groups/claimGroupRoles.service';
import NotifyClaimUsersModal from './NotifyClaimUsersModal';
import { SHOW_NOTIFY_CLAIM_USERS_MODAL } from '@rd-web-markets/market/dist/constants';
export default function SelectConsultants(_ref) {
  let {
    claimGroup,
    claimGroupId = null,
    consultantsAndAdmins,
    removeConsultantFromClaim,
    onClaimGroupConsultantRolesChange,
    size = 'sm',
    isUnderReview,
    pageAccess
  } = _ref;
  const groupId = claimGroup.id || claimGroupId;
  const consultants = claimGroup.consultants || claimGroup.consultants_attributes || claimGroup.consultant_roles;
  const leadConsultantExists = consultants.find(consultant => consultant.role === 'claim_group_access_lead_consultant');
  const dispatch = useDispatch();
  const [pendingConsultant, setPendingConsultant] = useState(null);
  const [showNotifyModal, setShowNotifyModal] = useState(false);

  // Errors are not caught here so the delete confirmation modal can show them and stay open.
  const removeConsultantFromExistingClaimGroup = async consultant => {
    // returns a claim group
    const claimGroupResult = await claimGroupRolesService.delete(groupId, consultant.user.id, consultant.role);
    onClaimGroupConsultantRolesChange(claimGroupResult);
  };
  const updateConsultantRolesExistingClaimGroup = async function (consultant) {
    let notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (consultant.role === 'claim_group_access_lead_consultant' && leadConsultantExists) {
      if (!window.confirm('This will override the current lead consultant')) {
        return;
      }
    }
    try {
      // returns a claim group
      const claimGroupResult = await claimGroupRolesService.create(groupId, consultant.id, consultant.role, notify);
      onClaimGroupConsultantRolesChange(claimGroupResult);
    } catch (error) {
      console.log(error);
      dispatch(handleError(error));
    }
  };
  const handleConsultantAdd = consultant => {
    if (groupId && SHOW_NOTIFY_CLAIM_USERS_MODAL) {
      // Existing claim group — show notify modal before calling the service
      setPendingConsultant(consultant);
      setShowNotifyModal(true);
    } else if (groupId) {
      // Existing claim group but modal not enabled for this market
      updateConsultantRolesExistingClaimGroup(consultant, false);
    } else {
      // New claim group — just add to local state
      onClaimGroupConsultantRolesChange(consultant);
    }
  };
  const addConsultantsToClaimGroupAndNotify = async selectedUserIds => {
    setShowNotifyModal(false);
    if (pendingConsultant) {
      const notify = selectedUserIds.length > 0;
      await updateConsultantRolesExistingClaimGroup(pendingConsultant, notify);
      setPendingConsultant(null);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ConsultantsWithAccess, {
    consultants: consultants,
    claimGroup: claimGroup,
    removeConsultantFromClaim: groupId ? removeConsultantFromExistingClaimGroup : removeConsultantFromClaim,
    canRemoveConsultant: !pageAccess || pageAccess.canEditConsultants,
    size: size,
    isUnderReview: isUnderReview,
    labelCols: 2
  })), (!pageAccess || pageAccess.canEditConsultants) && /*#__PURE__*/React.createElement(ConsultantsWithAccessForm, {
    consultantsAndAdmins: consultantsAndAdmins,
    claimGroup: claimGroup,
    handleConsultantToClaimGroupCreate: handleConsultantAdd,
    size: size,
    isUnderReview: isUnderReview,
    labelCols: 2
  }), showNotifyModal && pendingConsultant && /*#__PURE__*/React.createElement(NotifyClaimUsersModal, {
    show: showNotifyModal,
    onHide: () => {
      setShowNotifyModal(false);
      setPendingConsultant(null);
    },
    onSubmit: addConsultantsToClaimGroupAndNotify,
    users: [{
      id: pendingConsultant.id,
      name: pendingConsultant.name,
      email: pendingConsultant.email
    }],
    title: "Notify Users of New Claim",
    mode: "update"
  }));
}